import { envConfig } from './envs'

export const featureFlags = envConfig.featureFlags
